
import {
  SET_LOG,
  ADD_LOG,
  ADD_LOGS
} from '../actions/log';

var initVal = {
  logs:[]
}
export default function log(state = initVal, {type, payload}) {
  switch (type) {
    case SET_LOG:
      console.log('[AUDIT_SET] [LOG_REDUCER] SET_LOG - REPLACING all logs:', {
        previousCount: state.logs?.length || 0,
        newCount: payload?.length || 0,
        sampleOldLogs: state.logs?.slice(0, 2).map(l => ({action: l.action, old: l.old})),
        sampleNewLogs: payload?.slice(0, 2).map(l => ({action: l.action, old: l.old}))
      });
      return {
        ...state,
        logs: payload,
    }
    case ADD_LOG:
      console.log('[AUDIT_ADD] [LOG_REDUCER] ADD_LOG - Adding single log:', {
        previousCount: state.logs?.length || 0,
        newCount: (state.logs?.length || 0) + 1,
        addedLog: {
          action: payload?.action,
          old: payload?.old,
          hasAction: !!payload?.action,
          description: payload?.description?.substring(0, 40)
        }
      });
      return {
        ...state,
        logs: [...state.logs, payload],
    }
    case ADD_LOGS:
      console.log('[AUDIT_ADD_MULTI] [LOG_REDUCER] ADD_LOGS - Adding multiple logs:', {
        previousCount: state.logs?.length || 0,
        adding: payload?.length || 0,
        newCount: (state.logs?.length || 0) + (payload?.length || 0)
      });
      return {
        ...state,
        logs: [...state.logs, ...payload],
    }
      default:
          return state;
  }
}